import React, {useState, useRef, useEffect} from 'react';
import TeamShortTermGoalsListItem from './TeamShortTermGoalsListItem.mjs';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function TeamShortTermGoalsList({display_sel_stg}) 
{
    const { team_short_term_goals } = useCTAL();

    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [sel_stg_button_type, setSelSTGButtonType] = useState("btn btn-sm btn-secondary");
    
    const [sel_stg, setSelSTG] = useState();

    //const goal_list_style = { 'font-family': '"Courier New", Courier, monospace' };
    const goal_list_style = { 'font-family': 'monospace' };

    useEffect(() =>
    {
        if (DEBUG) console.log(`TeamShortTermGoalsList - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag) setSelSTGButtonType("btn btn-sm btn-secondary");
        else setSelSTGButtonType("btn btn-sm btn-primary");
    }, [form_changed_flag]);

    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    const display_stg = (stg) => { 
        if (DEBUG) console.log(`TeamShortTermGoalsList - display_stg: ${stg.Goal}`);
        setSelSTG(stg);
    }
    
    const select_stg = () => { 
        if (!form_changed_flag) return;

        if (DEBUG) console.log(`TeamShortTermGoalsList - select_stg: ${sel_stg.Goal}`);
        display_sel_stg(sel_stg);

        setFormChangedFlag(false);
    }

    return (
        <>
            <label class="select-floating-label" htmlFor="stg-list"><b>Short-Term Goals:</b></label>

            <select id="stg-list" class="form-select mt-1" size="6" style={goal_list_style} aria-label="Short-Term Goals:" onChange={form_changed}>
                { team_short_term_goals?.map( (stg, i) => ( <TeamShortTermGoalsListItem stg={stg} key={i} display_stg={display_stg} /> )) }
            </select>

            <div class="text-end mt-2">  
                <a id="sel-stg-btn" href="#" class={sel_stg_button_type} onClick={ () => select_stg() }>Display Short-Term Goal</a>
            </div>
        </>
    );
}
